export default __webpack_public_path__ + "static/media/list-ul.fca67451.svg";